import { render, staticRenderFns } from "./CommonDialog.vue?vue&type=template&id=5dcae584&scoped=true"
import script from "./CommonDialog.vue?vue&type=script&lang=js"
export * from "./CommonDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dcae584",
  null
  
)

export default component.exports